<template>
  <div class="box panel">
    <div class="box__inner">
      <p class="box__message" v-if="parent">{{ parent }} doesn't have any {{ pluralizedName }} yet</p>
      <p class="box__message" v-else>There are no {{ pluralizedName }} yet</p>
      <i class="box__icon material-icons">{{ icon }}</i>
      <router-link :to="{ name: newLink }" class="button">Add {{ name }}</router-link>
    </div>
  </div>
</template>

<script>
  import pluralize from 'pluralize';

  export default {
    name: 'admin-no-items',
    props: ['parent', 'name', 'icon', 'newLink'],

    computed: {
      pluralizedName() {
        return pluralize(this.name).toLowerCase();
      },
    },
  };
</script>
